import moment from "moment";

export function getPastPartByPercent(start, end) {
    if (!start || !end) return 0;
    const now = moment(new Date());
    if (now.isSame(start) || now.isBefore(start)) {
        return 0;
    }
    const duration = moment.duration(end.diff(start)).asSeconds();
    const elapsed = moment.duration(now.diff(start)).asSeconds();
    return elapsed * 100 / duration;
}